import { communityTrpc } from '@org/clients/community';

export function useCommunityRole() {
  const { data, isLoading } = communityTrpc.me.useQuery(undefined, {
    staleTime: 5 * 60 * 1000,
  });

  const role = data?.communityRole ?? 'member';
  const moderatedSpaceIds = data?.moderatedSpaceIds ?? [];

  return {
    role,
    isLoading,
    isAdmin: role === 'admin',
    isModerator: (spaceId?: string) => {
      if (role === 'admin') return true;
      if (role !== 'moderator' || !spaceId) return false;
      return moderatedSpaceIds.includes(spaceId);
    },
    isMember: role === 'member',
  };
}
